import { gql } from "urql";
export const UpdateEmailSettingMutation = gql `
    mutation UpdateEmailSetting($input: EmailSettingUpdateInput!) {
        emailSettings {
            updateEmailSettings(input: $input) {
                emailSettingId
                toUsers {
                    userId
                    name
                    imageUrl
                    email
                }
                emailSettingType
                isEnabled
            }
        }
    }
`;
export const UpdateOrganizationIntakeFormMutation = gql `
    mutation UpdateOrganizationIntakeForm(
        $input: OrganizationSettingsUpdateInput!
    ) {
        organizations {
            updateOrganizationSettings(input: $input) {
                organizationId
                settings {
                    intakeForm {
                        isActive
                        url
                    }
                }
            }
        }
    }
`;
